






import { Component, Vue } from 'vue-property-decorator';
import auth from '../utils/auth';

@Component
export default class Callback extends Vue {
  public created() {
    auth.handleAuthentication();
  }
}
